// Route configuration - centralized route component imports
import * as MainRoutes from '../components/appRoutes/MainRoutes';
import * as AuthRoutes from '../components/appRoutes/AuthRoutes';
import * as StaticRoutes from '../components/appRoutes/StaticRoutes';
import * as UtilityRoutes from '../components/appRoutes/UtilityRoutes';

export const routeConfig = {
    main: MainRoutes,
    auth: AuthRoutes,
    static: StaticRoutes,
    utility: UtilityRoutes
};
